import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import ReactHtmlParser from 'react-html-parser'

class Project extends Component {
  constructor (props) {
    super(props)

    this.clickThrough = false
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick (e) {
    const isMobile = window.matchMedia('(max-width: 1100px)').matches

    if (isMobile && !this.clickThrough) {
      e.preventDefault()
      this.clickThrough = true
    }
  }

  render () {
    return (
      <Link
        to={this.props.url}
        className='grid__block'
        style={{ backgroundImage: 'url(' + this.props.img + ')' }}
        onClick={this.handleClick}>
        <div className='grid__block-inner'>
          <span className='grid__block-label'>{this.props.label}</span>
          <h2 className='grid__block-title'>
            <span>{ReactHtmlParser(this.props.title)}</span>
            {this.props.subtitle}
          </h2>
          <div className='grid__block-bottom'>
            {this.props.tags && <p>{this.props.tags}</p>}
            <span className='grid__block-more'>See Case Study —</span>
          </div>
        </div>
      </Link>
    )
  }
}

Project.propTypes = {
  url: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  tags: PropTypes.string,
  img: PropTypes.string.isRequired
}

export default Project



// WEBPACK FOOTER //
// ./src/components/Grid/Project/index.js